import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { convertCurrency } from '../../../shared/utils/utils'
import { MatButton } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { JsonPipe, NgClass } from '@angular/common'
import { ItemProposalEditFormComponent } from './item-proposal-edit-form/item-proposal-edit-form.component'
import { ProposalItemService } from '../../../core/services/proposal/proposal-item/proposal-item.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ItemProposalIncludeFormComponent } from './item-proposal-include-form/item-proposal-include-form.component'
import { DialogChooseComponent } from '../../../shared/components/dialog-to-choose/dialog-to-choose.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ItemProposalDuplicateFormComponent } from './item-proposal-duplicate-form/item-proposal-duplicate-form.component'
import {
  ITEM_PROPOSTA_STATUS,
  PROPOSTA_STATUS,
} from '../../../shared/constants/proposal-status.constants'

@Component({
  selector: 'item-proposal-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatButton,
    NgClass,
    FormClientSearchComponent,
    MatProgressBar,
    JsonPipe,
    MatTooltipModule,
  ],
  templateUrl: './item-proposal-edit.component.html',
  styleUrl: './item-proposal-edit.component.scss',
  providers: [ProposalItemService],
  standalone: true,
})
export class ItemProposalEditComponent implements OnInit, AfterViewInit {
  constructor(
    private dialog: MatDialog,
    private proposalItemService: ProposalItemService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  itemsList: any[] = []
  requestingDiscountId = -1

  @Output() response = new EventEmitter<any>()
  @Output() responseRefresh = new EventEmitter<any>()
  @Input() idProposal = -1
  @Input() proposalInfo: any = {}
  @Input() statusId = -1
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    // {
    //   keyColumn: 'id',
    //   key: 'id',
    //   description: 'Id',
    // },
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'cost_IP',
      key: 'valorVendaFormatado',
      description: 'Venda',
    },
    {
      keyColumn: 'custoExtra_HK',
      key: 'saleFormatado',
      description: 'Venda Extra',
    },
    {
      keyColumn: 'status',
      key: 'descricaoStatus',
      description: 'Status',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true, duplicate: true },
      description: 'Ações',
    },
  ]
  page = 1
  rows = 10
  numberRows = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()

  displayedColumns: string[] = [
    // 'id',
    'location_OD',
    'servico_TS',
    'vehicle_VM',
    'cost_IP',
    'custoExtra_HK',
    'status',
    'action',
  ]

  inputSearchContact: any = { type: '', search: '' }
  listSearch: any = [
    {
      id: 'tipoContatoId',
      description: 'Tipo Contato',
      type: 'number',
      visible: false,
    },
    {
      id: 'descricao',
      description: 'Descrição',
      type: 'string',
      visible: true,
    },
  ]
  searchForm: any = { search: false, model: {} }
  loading = true

  ngOnInit(): void {
    this.getItemProposalbyProposal()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchContact()
    } else {
      this.getItemProposalbyProposal()
    }
  }

  getItemProposalbyProposal() {
    this.loading = true
    this.proposalItemService
      .listPagedProposalItemByProposal(this.idProposal, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.numberRows = response.totalItens
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchContact() {
    this.loading = true
    this.proposalItemService
      .searchPagedProposalItem(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          valorVendaFormatado: `R$ ${convertCurrency(item.valorVenda)}`,
          valorVendaTaxaFormatado: `R$ ${convertCurrency(item.valorComTaxa)}`,
          valorKmVendaFormatado: `R$ ${convertCurrency(item.valorKmVenda)}`,
          valorHoraVendaFormatado: `R$ ${convertCurrency(item.valorHoraVenda)}`,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
  }

  selectItemEvent(element: any) {
    this.item = element
    const dialogRef = this.dialog.open(ItemProposalEditFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: true, item: element, proposalInfo: this.proposalInfo },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      this.uploadList()
      this.responseRefresh.emit(true)
    })
  }

  addItemProposal() {
    const idCLient =
      this.proposalInfo.subClienteId && this.proposalInfo.subClienteId != 0
        ? this.proposalInfo.subClienteId
        : this.proposalInfo.clienteId
    const dialogRef = this.dialog.open(ItemProposalIncludeFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { idClient: idCLient, item: this.proposalInfo },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      this.uploadList()
      this.responseRefresh.emit(true)
    })
  }

  deleteItemEvent(element: any) {
    if (element.statusId != 4) {
      const dialogRef = this.dialog.open(DialogChooseComponent, {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        data: 'Deseja excluir esse item da proposta? Caso ele tenha algum processo de cotação ele será cancelado.',
      })
      dialogRef.afterClosed().subscribe((response) => {
        if (response == true) {
          this.deleteItemProposal(element)
        }
        // if (response == true) {
        //   this.uploadList()
        //   this.responseRefresh.emit(true)
        // }
      })
    } else {
      this.deleteItemProposal(element)
    }
  }

  deleteItemProposal(element: any) {
    this.proposalItemService.removeProposalItem(element.id).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.uploadList()
        this.responseRefresh.emit(true)
      },
      error: (err: ErrorRequestModel) => {
        this.snackbar.errorRequest(err)
      },
      complete: () => {},
    })
  }
  canRequestDiscount(element: any): boolean {
    return (
      element.statusId === ITEM_PROPOSTA_STATUS.REGULARIZADO &&
      (this.statusId === PROPOSTA_STATUS.ANALISE_CLIENTE ||
        this.statusId === PROPOSTA_STATUS.AGUARDANDO_DESCONTO_COMPRAS)
    )
  }

  requestDiscountEvent(element: any) {
    if (this.requestingDiscountId === element.id) {
      return
    }
    const dialogRef = this.dialog.open(DialogChooseComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: 'Deseja solicitar desconto para este item? Ele será enviado ao Compras.',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response === true) {
        this.requestDiscount(element)
      }
    })
  }

  requestDiscount(element: any) {
    this.requestingDiscountId = element.id
    this.proposalItemService.requestDiscount(element.id).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.uploadList()
        this.responseRefresh.emit(true)
      },
      error: (err: ErrorRequestModel) => {
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.requestingDiscountId = -1
      },
    })
  }

  duplicateItemProposal(element: any) {
    this.item = element
    const dialogRef = this.dialog.open(ItemProposalDuplicateFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: true, item: element, proposalInfo: this.proposalInfo },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      this.uploadList()
      this.responseRefresh.emit(true)
    })
    // this.proposalItemService.duplicateProposalItem(element.id).subscribe({
    //   next: (response: ResponseRequestModel) => {
    //     this.snackbar.success('Item duplicado com sucesso')
    //     this.uploadList()
    //     this.responseRefresh.emit(true)
    //   },
    //   error: (err: ErrorRequestModel) => {
    //     this.snackbar.errorRequest(err)
    //   },
    //   complete: () => {},
    // })
  }
}
